const COLOR_PRESETS = {
  red:    { bg: '#fee2e2', text: '#b91c1c', border: '#fecaca' },
  blue:   { bg: '#dbeafe', text: '#1d4ed8', border: '#bfdbfe' },
  orange: { bg: '#ffedd5', text: '#c2410c', border: '#fed7aa' },
  yellow: { bg: '#fef3c7', text: '#b45309', border: '#fde68a' },
  purple: { bg: '#ede9fe', text: '#6d28d9', border: '#ddd6fe' },
  green:  { bg: '#dcfce7', text: '#15803d', border: '#bbf7d0' },
  pink:   { bg: '#fce7f3', text: '#be185d', border: '#fbcfe8' },
  gray:   { bg: '#e5e7eb', text: '#1f2937', border: '#d1d5db' },
}

export const DEFAULT_STATUS_PRESET = 'blue'
export const DEFAULT_TAG_PRESET = 'purple'
export default COLOR_PRESETS
